var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRadarUrgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.14453,
    y: 5.14307,
    width: 6.85714,
    height: 6.85714,
    rx: 1.71429,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.14453,
    y: 5.14307,
    width: 6.85714,
    height: 6.85714,
    rx: 1.71429,
    fill: "#979797",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43136 2.57178C2.95797 2.57178 2.57422 2.95553 2.57422 3.42892V8.57178C2.57422 9.04516 2.95797 9.42892 3.43136 9.42892C3.90475 9.42892 4.2885 9.04516 4.2885 8.57178V5.14321C4.2885 4.66982 4.67226 4.28606 5.14565 4.28606H8.57422C9.04761 4.28606 9.43136 3.90231 9.43136 3.42892C9.43136 2.95553 9.04761 2.57178 8.57422 2.57178H3.43136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43136 2.57178C2.95797 2.57178 2.57422 2.95553 2.57422 3.42892V8.57178C2.57422 9.04516 2.95797 9.42892 3.43136 9.42892C3.90475 9.42892 4.2885 9.04516 4.2885 8.57178V5.14321C4.2885 4.66982 4.67226 4.28606 5.14565 4.28606H8.57422C9.04761 4.28606 9.43136 3.90231 9.43136 3.42892C9.43136 2.95553 9.04761 2.57178 8.57422 2.57178H3.43136Z",
    fill: "#979797",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.857143 0C0.383756 0 0 0.383756 0 0.857142V6C0 6.47339 0.383756 6.85714 0.857142 6.85714C1.33053 6.85714 1.71429 6.47339 1.71429 6V2.57143C1.71429 2.09804 2.09804 1.71429 2.57143 1.71429H6C6.47339 1.71429 6.85714 1.33053 6.85714 0.857143C6.85714 0.383756 6.47339 0 6 0H0.857143Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 8.5C13.45 11.2338 11.2338 13.45 8.5 13.45C5.76619 13.45 3.55 11.2338 3.55 8.5C3.55 5.76619 5.76619 3.55 8.5 3.55C11.2338 3.55 13.45 5.76619 13.45 8.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 8.5C13.45 11.2338 11.2338 13.45 8.5 13.45C5.76619 13.45 3.55 11.2338 3.55 8.5C3.55 5.76619 5.76619 3.55 8.5 3.55C11.2338 3.55 13.45 5.76619 13.45 8.5Z",
    fill: "#D01400",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 8.5C13.45 11.2338 11.2338 13.45 8.5 13.45C5.76619 13.45 3.55 11.2338 3.55 8.5C3.55 5.76619 5.76619 3.55 8.5 3.55C11.2338 3.55 13.45 5.76619 13.45 8.5Z",
    stroke: "white",
    strokeWidth: 1.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.3382 8.13502H9.39953V5.94851C9.39953 5.44053 9.12346 5.33562 8.78665 5.71661L8.5437 5.99268L6.48971 8.32827C6.20812 8.64852 6.32407 8.90803 6.74922 8.90803H7.68787V11.0945C7.68787 11.6025 7.96395 11.7074 8.30076 11.3264L8.5437 11.0504L10.5977 8.71477C10.8793 8.39453 10.7633 8.13502 10.3382 8.13502Z",
    fill: "#D01400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRadarUrgent);
export default __webpack_public_path__ + "static/media/ic_radar_urgent.1293c31e4ddc5e0f7d6d3513bd92cf64.svg";
export { ForwardRef as ReactComponent };